
import { supabase } from './client';

// Helper function to get the current user
export const getCurrentUser = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    
    if (error) {
      console.error('Error getting session:', error);
      return null;
    }
    
    if (session?.user) {
      console.log(`Current user: ${session.user.email} (${session.user.id})`);
    } else {
      console.log('No active user session found');
    }
    
    return session?.user || null;
  } catch (error) {
    console.error('Unexpected error in getCurrentUser:', error);
    return null;
  }
};

// Helper function to get the current user ID
export const getCurrentUserId = async () => {
  try {
    const user = await getCurrentUser();
    const userId = user?.id || null;
    
    if (userId) {
      console.log(`Current user ID: ${userId}`);
    } else {
      console.log('No user ID available');
    }
    
    return userId;
  } catch (error) {
    console.error('Unexpected error in getCurrentUserId:', error);
    return null;
  }
};

// Helper function to delete a user account
export const deleteUserAccount = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) {
      throw new Error('No active session');
    }
    
    const { error } = await supabase.functions.invoke('delete-user', {
      headers: {
        Authorization: `Bearer ${session.access_token}`,
      },
    });

    if (error) {
      throw new Error(error.message || 'Failed to delete account');
    }

    return { success: true };
  } catch (error: any) {
    console.error('Error deleting user account:', error);
    return { success: false, message: error.message };
  }
};
